import { useAuthSession } from '@modeling/account';
import { Layout, Menu } from 'antd';
import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAdminScope } from '../../context/AdminScopeContext';
import { createMenuItems, routeTitles } from '../../config/menuConfig';

const { Header, Sider, Content } = Layout;

function resolveSelectedKey(pathname: string): string {
  if (pathname === '/') return '/';
  const keys = Object.keys(routeTitles)
    .filter((key) => key !== '/')
    .sort((a, b) => b.length - a.length);
  return keys.find((key) => pathname === key || pathname.startsWith(`${key}/`)) ?? '/';
}

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const session = useAuthSession();
  const { scope } = useAdminScope();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = createMenuItems(session, scope);
  const selectedKey = resolveSelectedKey(location.pathname);

  const title = /^\/tenants\/[^/]+\/spaces/.test(location.pathname)
    ? (routeTitles['/tenants/:tenantId/spaces'] ?? '空间管理')
    : routeTitles[selectedKey] ??
      (location.pathname.includes('/schema-profiles/')
        ? 'Schema 编辑'
        : location.pathname.includes('/workflow-profiles/')
          ? '工作流编辑'
          : 'DC Admin');

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        {!collapsed && (
          <div
            style={{
              fontSize: 18,
              fontWeight: 600,
              textAlign: 'center',
              height: 32,
              margin: 16,
              color: '#fff',
            }}
          >
            DC Admin
          </div>
        )}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          onClick={({ key }) => {
            if (key !== 'logout') {
              navigate(key);
            }
          }}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: '0 24px',
            background: '#fff',
            fontSize: 18,
            fontWeight: 500,
            lineHeight: '64px',
          }}
        >
          {title}
        </Header>
        <Content style={{ margin: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
